<template>
  <img :src="iconSrc" :class="$style.icon" />
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import IconPlanBadgePr from '@/assets/images/icons/badge-pr.svg?url'
import IconPlanBadgeEntry from '@/assets/images/icons/badge-entry.svg?url'
import IconPlanBadgePro from '@/assets/images/icons/badge-pro.svg?url'
import IconPlanBadgeEnterprise from '@/assets/images/icons/badge-enterprise.svg?url'

import { Plan } from '@/types/schema.generated'

const props = defineProps<{ plan: Plan }>()

const iconSrc = computed(() => {
  switch (props.plan) {
    case Plan.V2022_1Pr:
      return IconPlanBadgePr
    case Plan.V2022_1Entry:
      return IconPlanBadgeEntry
    case Plan.V2022_1Pro:
      return IconPlanBadgePro
    case Plan.V2022_1Enterprise:
      return IconPlanBadgeEnterprise
    default:
      return undefined
  }
})
</script>

<style lang="scss" module>
.icon {
  width: 1em;
  height: 1em;
}
</style>
